module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_litz_sm-164beb8accf91be5d21624b7111e297d.png";